module.exports = __webpack_public_path__ + "img/4_no.c592a66b.svg";